import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const RidesApi = createApi({
  reducerPath: "RidesApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["RIDESAPI"],
  endpoints: (build) => ({
    getAllRides: build.query({
      query: ({
        page = 1,
        status = "",
        vehicleType = "",
        rideType = "",
        paymentMethod = "",
        userId = "",
        driverId = "",
        search = "",
      }) => ({
        url: `/rides?page=${page}&status=${status}&vehicleType=${vehicleType}&rideType=${rideType}&paymentMethod=${paymentMethod}&userId=${userId}&driverId=${driverId}&search=${search}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["RIDESAPI"],
    }),

    getRideById: build.query({
      query: ({ id }) => ({
        url: `/rides/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["RIDESAPI"],
    }),
    createRide: build.mutation({
      query: ( data ) => ({
        url: `/rides`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["ADMINAPI"],
    }),
    // Future: you can add ride update/cancel endpoints if needed
    updateRide: build.mutation({
      query: ({ id, data }) => ({
        url: `/rides/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["RIDESAPI"],
    }),

    deleteRide: build.mutation({
      query: ({ id }) => ({
        url: `/rides/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["RIDESAPI"],
    }),
  }),
});

export const {
  useGetAllRidesQuery,
  useGetRideByIdQuery,
  useCreateRideMutation,
  useUpdateRideMutation,
  useDeleteRideMutation,
} = RidesApi;
